<template lang="pug">
  div.relative.fill-height.pb-4
    iframe.sdo-card(
      allow="autoplay;camera;microphone;display-capture;\
      fullscreen;picture-in-picture;screen-wake-lock;clipboard-write"
      :src="url"
      width="100%"
      height="100%"
    )
</template>

<script>
export default {
  name: 'JazzSdk',
  props: {
    meeting: { type: Object, default: null },
  },
  computed: {
    url() {
      const regex = 'psw=.+';
      const str = this.meeting.url.match(regex);
      return `https://vc-backend.pfdo.ru/${this.meeting.options.room}?${str}`;
    },
  },
};
</script>
<style lang="scss" scoped>
.fill-heght {
  min-height: 600px;
}
</style>
